import _ from 'lodash';
import Vue from 'vue';
import VueRouter from 'vue-router';
import paths from './paths';
import store from '@/store';
import { etapaAtualDe, mesmaRota } from '@/util/onboarding';
import { guardarRotaPretendida } from '@/util/deeplink';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: paths,
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const user = store.getters.user;
  const isLogged = user && user.id;

  if (to.meta.public && isLogged) {
    return next({ path: '/delivery' });
  }

  if (!to.meta.public && !isLogged) {
    // Guarda o destino antes de mandar pro login: sem isso o link único (deeplink)
    // aberto por quem não está logado desembocaria sempre na home do painel.
    guardarRotaPretendida(to.fullPath);
    if (to.fullPath !== '/login') {
      window.sessionStorage.setItem('redirectAfterLogin', to.fullPath);
    }
    return next({ path: '/login' });
  }

  if (isLogged && to.meta.perfis) {
    const perfilAcesso = user.perfil_acesso || 'administrador';
    if (!to.meta.perfis.includes(perfilAcesso)) {
      return next({ path: '/delivery/home' });
    }
  }

  // Onboarding pendente: o parceiro fica restrito à tela da etapa da vez, mesmo
  // digitando a URL direto. Reforça o bloqueio do menu (AppDrawer.itemBloqueado).
  // No login o onboardingData ainda não carregou e nada é bloqueado — quem
  // conduz o parceiro até a tela é o modal (DialogOnboarding, persistente).
  const root = router.app && router.app.$root;
  if (root && root.isOnboardingPendente && to.path.indexOf('/delivery') === 0) {
    const etapa = etapaAtualDe(root.onboardingData);
    if (etapa && !mesmaRota(to.path, etapa.rota)) {
      return next({ path: etapa.rota });
    }
  }

  next();
});

export default router;
